import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class CerService {
  constructor(private storageService: StorageService) {}

  getStorageCer(id: number) {
    const cers = this.storageService.getCers();
    if (cers) {
      for (let i = 0; i < cers.length; i++) {
        if (cers[i].id === id) {
          return cers[i];
        }
      }
    }
    return null;
  }
}
